import * as React from 'react';
import { SVGProps } from 'react';

const SvgGoldStatus = (props: SVGProps) => {
  return (
    <svg
      viewBox="0 0 68 68"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g fillRule="evenodd" clipRule="evenodd">
        <path
          d="M20.744 20.775c0 4.947-2.494 9.294-6.255 11.773-.6.396-1.103.341-1.607 0-3.734-2.534-6.255-6.84-6.255-11.773 0-4.946 2.575-9.157 6.255-11.773.558-.395.94-.463 1.607 0 3.72 2.562 6.255 6.827 6.255 11.773Zm26.789 0c0 4.947 2.494 9.294 6.255 11.773.6.396 1.117.341 1.621 0 3.734-2.534 6.255-6.84 6.255-11.773 0-4.946-2.576-9.157-6.255-11.773-.558-.395-.94-.463-1.621 0-3.72 2.562-6.255 6.827-6.255 11.773Z"
          fill="#78C2A4"
        />
        <path
          d="M52.003 30.954c-2.466 4.279-2.494 9.293-.477 13.327.313.64.79.858 1.39.804 4.497-.327 8.83-2.794 11.31-7.072 2.466-4.279 2.344-9.225.477-13.327-.286-.627-.586-.872-1.39-.804-4.497.368-8.844 2.793-11.31 7.072Zm-35.728 0c2.466 4.279 2.493 9.293.477 13.327-.328.64-.79.858-1.39.804-4.51-.327-8.844-2.794-11.31-7.072-2.467-4.279-2.344-9.225-.464-13.327.287-.627.586-.872 1.39-.804 4.497.368 8.83 2.793 11.297 7.072Z"
          fill="#95D6A4"
        />
        <path
          d="M50.177 36.432a13.835 13.835 0 0 0 1.362 7.85c.314.64.79.858 1.39.803 4.497-.327 8.83-2.793 11.31-7.072 1.594-2.752 2.112-5.764 1.772-8.666a13.81 13.81 0 0 1-1.772 5.355c-2.466 4.279-6.8 6.745-11.31 7.072-.613.04-1.076-.164-1.39-.804a13.56 13.56 0 0 1-1.362-4.538Zm-32.063 0a13.835 13.835 0 0 1-1.363 7.85c-.327.64-.79.858-1.39.803-4.51-.327-8.843-2.793-11.31-7.072-1.58-2.752-2.098-5.764-1.771-8.666a13.81 13.81 0 0 0 1.771 5.355c2.467 4.279 6.8 6.745 11.31 7.072.6.04 1.077-.164 1.39-.804a13.88 13.88 0 0 0 1.363-4.538Z"
          fill="#78C2A4"
        />
        <path
          d="M53.856 39.484c-4.279 2.467-6.813 6.8-7.072 11.31-.041.709.259 1.132.804 1.404 4.06 1.962 9.048 2.003 13.326-.477 4.279-2.466 6.65-6.813 7.073-11.31.068-.695-.069-1.05-.804-1.403-4.075-1.935-9.048-2.004-13.327.476Zm-39.435 0c4.279 2.467 6.8 6.8 7.072 11.31.041.709-.259 1.132-.804 1.404-4.06 1.949-9.048 1.99-13.326-.49C3.083 49.24.726 44.893.29 40.397c-.068-.695.069-1.05.804-1.404 4.075-1.921 9.048-1.99 13.327.49Z"
          fill="#B3E59F"
        />
        <path
          d="M47.111 48.533a15.398 15.398 0 0 0-.327 2.248c-.041.709.259 1.13.804 1.403 4.06 1.963 9.048 2.004 13.326-.476 4.28-2.467 6.65-6.814 7.073-11.31.054-.518-.014-.845-.368-1.131-.886 3.679-3.12 7.058-6.705 9.13-4.278 2.466-9.265 2.438-13.326.476a1.583 1.583 0 0 1-.477-.34Zm-25.931 0c.163.735.272 1.485.327 2.248.04.709-.259 1.13-.804 1.403-4.074 1.963-9.062 2.004-13.34-.476C3.084 49.24.727 44.894.29 40.398c-.055-.518.013-.845.368-1.131.885 3.679 3.12 7.058 6.704 9.13 4.278 2.466 9.266 2.438 13.326.463.191-.082.355-.191.49-.327Z"
          fill="#95D6A4"
        />
        <path
          d="M50.735 47.933c-4.946 0-9.293 2.493-11.773 6.254-.395.6-.34 1.104 0 1.608 2.535 3.734 6.84 6.255 11.773 6.255 4.947 0 9.157-2.576 11.774-6.255.395-.559.463-.94 0-1.608-2.562-3.706-6.84-6.254-11.774-6.254Zm-33.194 0c4.947 0 9.294 2.493 11.774 6.254.395.6.34 1.104 0 1.608-2.535 3.734-6.827 6.255-11.774 6.255-4.946 0-9.157-2.576-11.773-6.255-.395-.559-.463-.94 0-1.608 2.562-3.706 6.84-6.254 11.773-6.254Z"
          fill="#CCF49F"
        />
        <path
          d="M39.562 53.33a9.77 9.77 0 0 0-.613.858c-.396.6-.341 1.103 0 1.607 2.534 3.734 6.84 6.255 11.773 6.255 4.946 0 9.157-2.575 11.773-6.255.395-.558.463-.94 0-1.607a10.13 10.13 0 0 0-.64-.859c-2.644 3.23-6.582 5.423-11.147 5.423S42.151 56.6 39.562 53.33Zm-10.847 0c.218.272.423.558.613.858.396.6.341 1.103 0 1.607-2.534 3.734-6.826 6.255-11.773 6.255-4.946 0-9.157-2.575-11.773-6.255-.395-.558-.463-.94 0-1.607.204-.3.422-.586.64-.859 2.644 3.23 6.582 5.423 11.133 5.423 4.565 0 8.571-2.153 11.16-5.423Z"
          fill="#B3E59F"
        />
        <path
          d="M12.977 29.823a35.37 35.37 0 0 0 .585 3.312h41.18l-2.549-3.312H12.977Z"
          fill="#5490F9"
        />
        <path
          d="M34.139 33.12h20.59c.245-1.13.435-2.234.585-3.31H34.14v3.31Z"
          fill="#DA4A54"
        />
        <path
          d="M13.549 33.121c1.867 8.68 6.936 19.186 19.73 26.585.287.136.573.218.86.218V33.121h-20.59Z"
          fill="#DD636E"
        />
        <path
          d="M33.267 56.408c-11.283-6.227-16.843-14.635-19.5-22.306 2.03 8.489 7.195 18.49 19.513 25.604.286.136.572.218.859.218v-3.312c-.3 0-.586-.068-.873-.204Z"
          fill="#DA4A54"
        />
        <path
          d="M54.401 34.552C51.69 42.1 46.13 50.304 35.065 56.395c-.313.15-.627.218-.926.218v3.311c.286 0 .572-.068.858-.218 12.1-6.99 17.292-16.774 19.404-25.154Z"
          fill="#5490F9"
        />
        <path
          d="M33.543.381c-2.86 2.773-12.329 11.16-24.815 13.448-1.081.208-1.36.398-1.517 1.525-.872 6.48-2.965 35.663 26.106 52.368.715.364 1.447.364 2.197 0 16.375-9.41 22.862-22.77 25.251-33.809L34.433 0c-.297 0-.593.121-.89.381Z"
          fill="#F2CD2C"
        />
        <path
          d="M7.333 29.702c.174 1.352.419 2.756.75 4.211h52.7l-3.262-4.21H7.333Z"
          fill="#E6BD19"
        />
        <path
          d="M34.433 33.913h26.35c1.848-8.56 1.238-15.735.854-18.577-.157-1.109-.453-1.317-1.5-1.507C47.67 11.559 38.183 3.17 35.323.38c-.297-.259-.593-.38-.89-.38v33.913Z"
          fill="#C6A51A"
        />
        <path
          d="M47.483 12.9a.3.3 0 0 0-.417.003L42.631 17.3a.274.274 0 0 0-.082.195v6.376c0 .06.02.118.057.167a.3.3 0 0 0 .417.053l8.717-6.667a.272.272 0 0 0 .024-.418L47.483 12.9Zm-.819-.429a.867.867 0 0 1 1.213-.01l4.282 4.106a.885.885 0 0 1-.074 1.339l-8.717 6.666a.868.868 0 0 1-1.216-.16.885.885 0 0 1-.183-.54v-6.377c0-.237.095-.463.26-.627l4.435-4.397Zm5.296 7.034a.3.3 0 0 0-.416-.061l-2.8 2.046a.273.273 0 0 0 0 .446l2.8 2.045a.3.3 0 0 0 .177.058.286.286 0 0 0 .292-.28v-4.092a.272.272 0 0 0-.053-.162Zm-.75-.55a.868.868 0 0 1 1.212.188c.11.15.172.334.172.524v4.091c0 .496-.4.88-.873.88a.868.868 0 0 1-.512-.167l-2.8-2.046a.884.884 0 0 1 0-1.425l2.8-2.045Zm-3.68 3.868a.301.301 0 0 0-.352 0l-1.852 1.34a.273.273 0 0 0-.084.354l1.853 3.42a.298.298 0 0 0 .519 0l1.852-3.42a.273.273 0 0 0-.084-.354l-1.852-1.34Zm-.685-.49a.867.867 0 0 1 1.018 0l1.852 1.34c.355.257.47.743.257 1.136l-1.852 3.42a.869.869 0 0 1-1.532 0l-1.852-3.42a.884.884 0 0 1 .257-1.136l1.852-1.34Z"
          fill="#7A5E0F"
        />
        <path
          d="M34.433 33.914h26.35c.314-1.438.558-2.842.75-4.21h-27.1v4.21Z"
          fill="#A08615"
        />
        <path
          d="M8.083 33.913c2.389 11.039 8.876 24.4 25.25 33.81.367.173.733.277 1.1.277V33.913H8.082Z"
          fill="#C6A51A"
        />
        <path
          d="M25.17 38.4a.3.3 0 0 0-.416.004L20.319 42.8a.274.274 0 0 0-.082.195v6.376c0 .06.019.118.057.167a.3.3 0 0 0 .417.053l8.716-6.667a.272.272 0 0 0 .024-.418L25.17 38.4Zm-.818-.429a.867.867 0 0 1 1.213-.01l4.282 4.106a.885.885 0 0 1-.074 1.339l-8.717 6.666a.868.868 0 0 1-1.216-.16.885.885 0 0 1-.184-.54v-6.377c0-.237.095-.463.261-.627l4.435-4.397Zm5.295 7.034a.3.3 0 0 0-.415-.061l-2.8 2.045a.273.273 0 0 0 0 .446l2.8 2.046a.3.3 0 0 0 .177.058.286.286 0 0 0 .292-.28v-4.092a.272.272 0 0 0-.054-.162Zm-.75-.55a.868.868 0 0 1 1.212.188c.111.15.172.334.172.524v4.091c0 .496-.4.88-.872.88a.868.868 0 0 1-.512-.167l-2.8-2.046a.884.884 0 0 1 0-1.425l2.8-2.045Zm-3.68 3.868a.301.301 0 0 0-.351 0l-1.853 1.34a.273.273 0 0 0-.083.354l1.852 3.42a.298.298 0 0 0 .518 0l1.853-3.42a.273.273 0 0 0-.083-.354l-1.853-1.34Zm-.684-.49a.867.867 0 0 1 1.017 0l1.853 1.34c.355.256.47.743.257 1.136l-1.853 3.42a.869.869 0 0 1-1.531 0l-1.853-3.42a.884.884 0 0 1 .257-1.136l1.853-1.34Z"
          fill="#7A5E0F"
        />
        <path
          d="M33.316 63.512C18.877 55.61 11.762 44.917 8.362 35.162c2.598 10.795 9.207 23.515 24.972 32.56.366.174.732.278 1.099.278v-4.211c-.384 0-.75-.087-1.117-.277Z"
          fill="#A08615"
        />
        <path
          d="M60.364 35.732c-3.47 9.6-10.585 20.033-24.745 27.78a2.75 2.75 0 0 1-1.186.276V68c.366 0 .733-.086 1.099-.277 15.485-8.89 22.13-21.332 24.832-31.99Z"
          fill="#E6BD19"
        />
      </g>
    </svg>
  );
};
export default SvgGoldStatus;
